// extracted by mini-css-extract-plugin
export default {"container":"wKprfbO4suEtbElZ7XmJ","submit":"ivhpLPKgahTnNChhJoSG","title":"ZBANVBsJt9LVt19DNxxW","error-message":"epij48Bek2wo9xe2CEaU"};